export default "__VITE_ASSET__CtcKiTo3__"